export default {
  state: {
    // список доступных actions по секциям
    customRolesActions: null,
    baseRoles: {
      GUEST: {
        name: 'Гость',
        value: 'GUEST',
        integerValue: 10
      },
      REPORTER: {
        name: 'Докладчик',
        value: 'REPORTER',
        integerValue: 20
      },
      DEVELOPER: {
        name: 'Разработчик',
        value: 'DEVELOPER',
        integerValue: 30
      },
      ADMIN: {
        name: 'Администратор',
        value: 'ADMIN',
        integerValue: 40
      },
      OWNER: {
        name: 'Владелец',
        value: 'OWNER',
        integerValue: 50
      }
    }
  },
  mutations: {
    setCustomRolesActions(state, payload) {
      state.customRolesActions = payload;
    }
  },
  actions: {
    setCustomRolesActions(state, payload) {
      state.commit('setCustomRolesActions', payload);
    }
  },
  getters: {
    getCustomRolesActions(state) {
      return state.customRolesActions;
    },
    getBaseRoles(state) {
      return state.baseRoles;
    }
  }
};
